import ViewPaymentProfile from "components/PaymentProfile/ViewPaymentProfile";

const PaymentProfilePage: React.FC = () => {
  return <ViewPaymentProfile />;
};

export default PaymentProfilePage;
